import { createStyles, makeStyles, Theme } from '@material-ui/core';

const AppStyles = makeStyles((theme: Theme) =>
  createStyles({
    variantSuccess: {
      backgroundColor: 'var(--success)',
      fontWeight: 700,
    },
    variantError: {
      backgroundColor: 'var(--rojo-error)',
      fontWeight: 700,
      padding: '.625rem 9.375rem',
      [theme.breakpoints.down('sm')]: {
        padding: '.375rem 1rem .375rem 1.25rem',
      },
    },
    variantInfo: {
      backgroundColor: 'var(--azul-info)',
      fontWeight: 700,
    },
    variantWarning: {
      backgroundColor: 'var(--amarillo-advertencia)',
      fontWeight: 700,
    },
  })
);

export default AppStyles;
